export default __webpack_public_path__ + "static/media/icon-writing.e5d77e65.svg";